import { useLocation } from "react-router-dom";

import { ModalRoute } from "../../Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../../Navigation/ModalTransitionSwitch";
import { ShiftInviteBookedBottomSheetContainer } from "./ArrivalTime/ShiftBookedBottomSheetContainer";
import { SHIFT_INVITE_BOOKED_CONFIRMATION_PATH, SHIFT_INVITE_MODAL_PATH } from "./paths";

interface ShiftInviteModalRoutesProps {
  basePath: string;
}

export function ShiftInviteModalRoutes(props: ShiftInviteModalRoutesProps) {
  const { basePath } = props;
  const location = useLocation();

  const goBackPath = `${basePath}${location.search}`;

  return (
    <ModalTransitionSwitch>
      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={goBackPath}
        path={`${basePath}/${SHIFT_INVITE_MODAL_PATH}/${SHIFT_INVITE_BOOKED_CONFIRMATION_PATH}`}
        render={({ modalState }) => {
          return <ShiftInviteBookedBottomSheetContainer modalState={modalState} />;
        }}
      />
    </ModalTransitionSwitch>
  );
}
